export default __webpack_public_path__ + "static/img5-82b5aef043336bc99511760d0aae2f9a.png";